/**
 * The legacy API's `Course/GetPages` and `Page/GetProperties` both give a page avatar as a path or
 * URL, with stand-ins for a page that has none.
 */

const defaultAvatar = '/img/thumb/DefaultCourseAvatar.jpg';

const normalize = (avatarValue: string | undefined): string => (typeof avatarValue === 'string' ? avatarValue.trim().toLowerCase() : '');

/** The legacy API answers the default avatar, nothing or `false` for a page without a page avatar. */
const isStandIn = (avatarValue: string | undefined): boolean => {
  const normalized = normalize(avatarValue);
  return normalized === '' || normalized === 'false' || normalized.includes('defaultcourseavatar');
};

/**
 * `Course/GetPages` also answers a page avatar under the old, guessable `CoursePageAvatar/avatar_…`
 * name for as long as that file is on disk. That is not the author's choice either; an uploaded image
 * lies in the author's media library instead.
 */
export const isAuthorsOwnImage = (avatarValue: string | undefined): boolean => !isStandIn(avatarValue) && !normalize(avatarValue).includes('/coursepageavatar/');

/**
 * `Page/GetProperties` gives the author's uploaded image or the default avatar, never the page
 * snapshot, so a page without an image of its own shows the page avatar the page list shows.
 */
export const avatarShownInPageProperties = (propertiesAvatar: string, pageTreeAvatar = ''): string => {
  if (isAuthorsOwnImage(propertiesAvatar)) return propertiesAvatar;
  return isStandIn(pageTreeAvatar) ? defaultAvatar : pageTreeAvatar;
};
